/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ItemDisputationTypeWithRelations } from '../../models/item-disputation-type-with-relations';

export interface GetItemDisputationTypesList$Params {
}

export function getItemDisputationTypesList(http: HttpClient, rootUrl: string, params?: GetItemDisputationTypesList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ItemDisputationTypeWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, getItemDisputationTypesList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ItemDisputationTypeWithRelations>>;
    })
  );
}

getItemDisputationTypesList.PATH = '/item-disputation-types';
